(function(){
  var mask;

  Pegasus.ResizingCanvasState = Em.State.extend({
    hover: Em.K,
    hoverRow: Em.K,
    setup: function(){
      mask = mask || $('<div class="vr-resizing-mask"/>');
      mask.remove().appendTo('.center');
      Pegasus.lookupController('blockOperations').set('content', null);
      Pegasus.lookupController('rowOperations').set('content', null);
    },
    exit: function(){
      this._super.apply(this, arguments);
      mask.remove();
    }
  });
})();
